7/*
* @Author: LiuMouLiang
* @Date:   2021-08-17 15:22:03
* 全局配置API
https://docs.winbaoxian.cn/api/group_insurance/#api-ConservationController-calcPremium
https://docs.winbaoxian.cn/api/bxs-pc/#api-MainController-getAllGroupProductFilterTag()
*/
'use strict';
import { _for } from "tools";
import { OSS_URL, BASE_API } from './host';

const APIURL = {
	//公共
	'oss/getAuthInfo': OSS_URL + '/oss/getAuthInfo',
};
const baseURL = [
    //通用
    'getUserSalesQualification', //新版认证接口
    'group/product/fuzzyQuery', //下拉选择框模糊查询团险产品
    'group/product/main/getAllCompany', //团险公司列表
    'getBankCodeList', //开户行
    'getBankAreaList', //开户地(获取第三方开户地区)
    'getAreaCode', //开户地(/bq-invoice.html?nw=1&policyUuid=86ce4cd5b97c4d0faef7cbb3c37b200c88&productId=905&bqType=010)
    'getBankNetworkList', //开户网点
    'conservation/getBannerByType', // 查询banner接口
    'user/isppshow', // 获取推广费是否展示
    'main/getPushMoneySwitchStatus', //AC分离，是否认证状态获取
    'validPersonInfo', //校验实人认证-验证人员有效性
    'getAllGroupProductFilterTag', //获取产品标签列表
    /* 发票 */
    'invoice/getInvoiceInfo', //获取发票信息
    /* 地址 */
    'getConstructionAreaCode', //建工施工地址表
    /* #投保# */
    'tmpOrder/getOfflineTempOrderData', //线下录单 - 获取待处理的临时订单数据
    'tmpOrder/submitOfflineTempOrder', // 线下录单 - 提交临时订单数据
    'tmpOrder/getOfflineTempOrderDetail',// 线下录单 - 获取线下提交订单详情
    'group/conservation/pcCanApplyConservationList', //87877
    'product/getPremiumAndMissionConfig', //获取产品佣金和加奖配置
    'product/getProductDictionaryDTOList', //获取产品字典
    /* #保全# */
    'conservation/pc/pcCanApplyConservationList', //pc端可保全列表(经纪)
    'conservation/config', //团险产品保全配置
    'conservation/getSettingsByPolicyUuid', //?获取保全 初始化数据
    'conservation/riskLimitConservation',
    'conservation/getSettingsByConservationUuid', //?获取保全设置数据(成单后)
    'conservation/downloadArchiveInfo', //下载保全资料
    'conservation/getInitOrderInfoByPolicyUuid', //查询职级人员信息
    'conservation/initThirdPremium', //第三方计算保费  isThirdTrial 判断
    'conservation/calcPremium', //保费计算
    'conservation/submitAllOrderInfo', //最后一步提交
    'conservation/submitDetailInfo', //上传保全资料
    'conservation/submitInitInfo', //提交保全申请，- 提交资料前
    'conservation/orderDetail', //保全详情
    'tempConservation/saveInitInfo', //保存待完善
    'tempConservation/getTempData', //读取待完善
    // 'validPersonInfo', //验证人员有效性
    'conservation/verifyPersonsInfo', //校验保全人员信息（姓名、身份证、生日不能空/年龄在指定范围）
    'conservation/getGroupConservationPolicy', //获取保全订单信息
    'conservation/canApplyConservationJobCode', // 判断保全职业能否申请保全 == 应用于新增职业与拒保
    //# 批量导入
    'conservation/importChangePersonsExcel', //批量换人
    'conservation/importDeletePersonsExcel', //批量减人
    'conservation/importAddPersonsExcel', //批量加人
    'conservation/importMixedPersonsExcel', //批量混合
    'conservation/downloadConservationExcelTemp', //下载模板
    'conservation/downloadConservationExcelNewTemp', //新增职业时使用的下载模板
    /* 订单 */
    'order/getElectronicPolicy', //下载电子保单
    'order/sendBatchElectronicPolicy', //提交电子保单(请求特殊-抛弃)
    /* 风控 */
    // 另外一个是提交新单时触发 == 企业风控
    'getPersonRiskInfo', //人员风控 == 被保人
    'insureGroupUserLimit', // 代理人投保限制
    'insureGroupUserRealNameLimit', // 是否需要代理人实名
    'order/getPolicyCheckMaterialInfo', // 获取保单核保资料
    'order/uploadPolicyCheckMaterialInfo', // 上传保单核保资料
    /* 未知接口 */
    'getClauseShowByPolicyUuid',
    // 新配置产品算费接口
    'insurance/input',
    'order/getHistoryGroupApplicantInfo', // 获取历史团体投保人信息
    'order/getHistoryPolicyPersons', // 根据订单uuid获取最新被保人员名单
];

//科技接口
const kjURL = {
    'conservation/canApplyConservation': 'api/conservation/canApplyConservation', //验证保单有效性
}
_for(baseURL,item=>{
	APIURL[item] = `/api/${item}`;
});
_for(kjURL,(item,key)=>{
	APIURL[key] = item;
});
export default APIURL;



// WEBPACK FOOTER //
// ./src/libs/APIURL.js